module.exports = __webpack_public_path__ + "akne_6_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_6_before.jpg
// module id = 926
// module chunks = 0